import API from './api';

export const loginUser = (credentials) => API.post('/auth/login', credentials);
export const logoutUser = () => API.post('/auth/logout');
export const getMe = () => API.get('/auth/me');
export const updateMe = (data) => API.put('/auth/me', data);
export const uploadAvatar = (file) => {
  const form = new FormData();
  form.append('file', file);
  return API.post('/auth/me/avatar', form);
};
export const deleteAvatar = () => API.delete('/auth/me/avatar');
const BASE = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/api\/?$/, '');
export const getAvatarUrl = (filename) => filename ? `${BASE}/api/auth/avatars/${filename}` : null;
export const getUsers = () => API.get('/auth/users');
export const createUser = (data) => API.post('/auth/users', data);
export const updateUser = (id, data) => API.put(`/auth/users/${id}`, data);
export const deleteUser = (id) => API.delete(`/auth/users/${id}`);
